import React from "react"
import {
  Container,
  Button,
  ListGroup,
  ListGroupItem,
  Badge,
  Input,
} from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Trans, useLingui } from "@lingui/react"
import { connect } from "react-redux"
import {
  patchVslaItem,
  patchGroupItem,
} from "../../store/actions/updateVslaAndGroup"
import { selectBalance } from "../../store/reducers/getVslaBalance"
import { selectVslaDebtBalance } from "../../store/reducers/getVslaBalance"
import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import { toast } from "react-toastify"
import { getMemberBalanceByMemberId } from "../../store/reducers/transactions/actions"
import { t } from "@lingui/macro"
import { setCurrentPage } from "../../store/reducers/navigation"
import StellarLoader from "../layout/StellarLoader"
import { backendAPI, blockchainAPI } from "../../store/api"
import ProjectSelector from "../layout/MultiSelector"
import LocationForm from "../layout/Location/LocationForm"
import { safeApiCall } from "../../store/api/offline"
import PropTypes from "prop-types"

const SuccessMessage = () => {
  return (
    <div className="toast__success-body">
      <Trans id="notifications.edit_success" />
    </div>
  )
}

const ErrorMessage = () => {
  return (
    <div style={loadingStyle}>
      <Trans id="notifications.edit_error" />
    </div>
  )
}


const inputStyle = {
  flex: "10",
  padding: "5px",
  fontFamily: "Fira Sans",
  fontSize: "20px",
  marginBottom: "15px",
}

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "1.8em",
  textAlign: "center",
  paddingBottom: "0.5em",
  margin: "34px 0 0 0",
}

const optionStyle = {
  padding: ".3rem",
  textAlign: "center",
  fontFamily: "Fira Sans",
  color: "#696969",
  fontStyle: "italic",
}
const linkReverseStyles = {
  display: "flex",
  justifyContent: "space-between",
}

const GroupSummary = (props) => {
  const { i18n } = useLingui()

  const notify = (msg) => toast.info(msg)
  const [iconStyle, setIconStyle] = React.useState({
    fontSize: "20px",
    float: "right",
    transform: i18n.locale === "ar" ? "rotateY(180deg)" : "none",
  })

  React.useEffect(() => {
    setIconStyle(prevState => ({
      ...prevState,
      transform: i18n.locale === "ar" ? "rotateY(180deg)" : "none",
    }))
  }, [i18n.locale])
  const [state, setState] = React.useState({
    isEditing: false,
    name: props.vslaSummary[0].group.description,
    location: props.vslaSummary[0].group.locality,
    savings_cycle: props.vslaSummary[0].group.cycle_duration,
    establishment_date: props.vslaSummary[0].group.establishment_date,
    project_ids: props.vslaSummary[0].group.projects,
    country: props.vslaSummary[0].group?.country,
    address: props.vslaSummary[0].group.address,
    loading: false,
    showLocationError: false,
  })

  React.useEffect(() => {
    setState({
      ...state,
      name: props.vslaSummary[0].group.description,
      location: props.vslaSummary[0].group.locality,
      savings_cycle: props.vslaSummary[0].group.cycle_duration,
      establishment_date: props.vslaSummary[0].group.establishment_date,
      project_ids: props.vslaSummary[0].group.projects,
      country: props.vslaSummary[0].group?.country,
      address: props.vslaSummary[0].group.address,
    })
  }, [props.vslaSummary])


  const [canEdit, setCanEdit] = React.useState(false)
  React.useEffect(() => {
    setCanEdit(
      props.isConnected &&
      props.group?.id &&
      !props.ongoingMeeting,
    )
  }, [props.isConnected, props.ongoingMeeting])

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const handleProjectChange = (selectedOptionId) => {
    onChange({
      target: {
        value: selectedOptionId || [],
        name: "project_ids",
      },
    })
  }

  const [isDeletable, setIsDeleteable] = React.useState(
    props.isConnected &&
    (props.ongoingMeeting ||
      props.vslaBalance?.length > 0 ||
      props.vslaDebt?.amount > 0 ||
      props.vsla?.status === "Inactive")
  )

  React.useEffect(() => {
    setIsDeleteable(
      props.isConnected &&
      (props.ongoingMeeting ||
        props.vslaBalance?.length > 0 ||
        props.vslaDebt?.amount > 0 ||
        props.vsla?.status === "Inactive")
    )
  }, [props.isConnected])

  const deleteVsla = () => {
    if (!isDeletable) {
      alert(t({ id: "notifications.cant_delete_group_has_funds" }))
      return
    }
    const headers = {
      headers: { Authorization: "Bearer " + localStorage.getItem("tokenBC") },
    }
    const headersHOL = {
      headers: {
        Authorization: "Bearer " + props.user.token || localStorage.getItem("token"),
      },
    }

    const { vsla, group } = props

    if (window.confirm(t({ id: "delete.vsla" }))) {
      const currentVslaCopy = vsla
      currentVslaCopy.status = "Inactive"
      const currentGroupCopy = group
      currentGroupCopy.status = "Inactive"
      setState({ ...state, loading: true })
      blockchainAPI
        .patch(`/vsla/${vsla?.id}`, currentVslaCopy, headers)
        .then(() => {
          return backendAPI.patch(
            `/groups-hedera/group_update/${group?.id}`,
            currentGroupCopy,
            headersHOL,
          )
        })
        .then(() => {
          notify(<SuccessMessage />)
        })
        .catch(() => {
          notify(<ErrorMessage />)
        })
        .finally(() => {
          setState({ ...state, loading: false })
        })
    }
  }

  const toggleEditVsla = () => {
    setState({ ...state, isEditing: !state.isEditing })
  }

  const updateGroup = () => {
    if (!props.transportedLocationData.valid) {
      setState({ ...state, showLocationError: true })
      setTimeout(() => {
        setState({ ...state, showLocationError: false })
      }, 4000)
      return
    }
    setState({ ...state, loading: true })
    // patch group in HOL
    const headers = {
      headers: { Authorization: "Bearer " + props.user.token },
    }
    const vslaData = props.vslaSummary[0].group
    let temp = { ...vslaData }
    delete temp.project
    delete temp.projects
    // Remove valid attribute from location data
    delete props.transportedLocationData.valid
    temp.name = state.name
    temp.locality = props.transportedLocationData.locality
      ? props.transportedLocationData.locality.name
      : ""
    temp.description = state.name
    temp.cycle_duration = state.savings_cycle
    temp.establishment_date = state.establishment_date
    temp.project_ids = state.project_ids
    temp.address = props.transportedLocationData
    temp.country = props.transportedLocationData.country
      ? props.transportedLocationData.country.name
      : ""
    const urlHOL = `/groups-hedera/group_update/${temp.id}`
    props
      .patchGroup(urlHOL, temp, headers)
      .then(() => {
        updateVslaBC()
      })
      .catch((error) => {
        setState({ ...state, loading: false })
        notify(<ErrorMessage />)
        console.log("Error: ", error)
      })
  }

  const updateVslaBC = async () => {
    // get vsla data
    const vsla_id = props.vsla?.id
    const vsla = await safeApiCall(
      {
        cacheEnabled: true,
        url: `/vsla/${vsla_id}`,
      },
      async () => blockchainAPI.get(`/vsla/${vsla_id}`),
    )
    let temp = { ...vsla.data }
    temp.description = state.name
    const urlBC = `/vsla/${vsla_id}`

    //patch vsla with new name
    props
      .patchVsla(urlBC, temp)
      .then(() => {
        notify(<SuccessMessage />)
      })
      .catch(() => {
        notify(<ErrorMessage />)
      })
      .finally(() => {
        setState({ ...state, loading: false, isEditing: false })
      })
  }
  if (state.loading) {
    return <StellarLoader />
  }

  if (props.vslaSummary[0].group.length !== 0) {
    return (
      <div>
        <div>
          <h4 style={headerStyle}>{props.vslaSummary[0].group.description}</h4>
        </div>
        <Container>
          <div style={optionStyle}>
            <h5>
              <Trans id="title_copy.more_details" />
            </h5>
          </div>

          <ListGroup flush>
            <span onClick={() => props.setPage("group-funds")}>
              <ListGroupItem
                className="justify-content-between textStyle"
                style={
                  i18n.locale === "ar"
                    ? linkReverseStyles
                    : loadingStyle
                }
              >
                <Trans id="menu.funds" />
                <FontAwesomeIcon style={iconStyle} icon="angle-right" />
                <Badge pill></Badge>
              </ListGroupItem>
            </span>
            <span
              name="members-view-button"
              onClick={() => props.setPage("group-memberList")}
            >
              <ListGroupItem
                className="justify-content-between textStyle"
                style={
                  i18n.locale === "ar"
                    ? linkReverseStyles
                    : loadingStyle
                }
              >
                <Trans id="menu.members" />
                <Badge pill></Badge>
                <FontAwesomeIcon style={iconStyle} icon="angle-right" />
              </ListGroupItem>
            </span>
            <span
              onClick={() => {
                if (!props.isConnected) {
                  return
                }
                props.setPage("group-settings")
              }}
            >
              <ListGroupItem
                className="justify-content-between textStyle"
                style={
                  i18n.locale === "ar"
                    ? {
                      ...linkReverseStyles,
                      color: props.isConnected ? "initial" : "grey",
                    }
                    : {
                      ...loadingStyle,
                      color: props.isConnected ? "initial" : "grey",
                    }
                }
              >
                <Trans id="menu.settings" />
                <FontAwesomeIcon style={iconStyle} icon="angle-right" />
              </ListGroupItem>
            </span>
          </ListGroup>
          <br />
          <br />
          <div style={optionStyle}>
            <h5>
              <Trans id="title_copy.vsla_actions" />
            </h5>
          </div>

          {state.isEditing && (
            <>
              <Input
                type="text"
                name="name"
                style={inputStyle}
                placeholder={t({ id: "placeholder_copy.create_group_name" })}
                onChange={onChange}
                value={state.name}
              />
              <LocationForm
                preset={state.address}
                validateData={state.showLocationError}
              />
              <ProjectSelector
                onChange={handleProjectChange}
                selectorOptions={
                  props.transportedLocationData.country
                    ? props.projects.filter(
                      ({ country }) =>
                        country === props.transportedLocationData.country.name,
                    )
                    : []
                }
                placeholderText={t({ id: "placeholder_copy.project_name" })}
                defaultOptions={state.project_ids}
              />
              {!["ar", "lb"].includes(i18n.locale) && (
                <Input
                  id="savings_cycle"
                  type="select"
                  name="savings_cycle"
                  style={{
                    flex: "10",
                    padding: "5px",
                    fontFamily: "Fira Sans",
                    fontSize: "20px",
                    marginTop:
                      state.project_ids.length === 2
                        ? "45px"
                        : state.project_ids.length > 2
                          ? "85px"
                          : "0px",
                    marginBottom: "15px",
                  }}
                  onChange={onChange}
                  value={state.savings_cycle}
                >
                  <option value="">
                    {t({ id: "placeholder_copy.savings_cycle" })}
                  </option>
                  <option value="6">{t({ id: "dropdowns.six_months" })}</option>
                  <option value="9">{t({ id: "dropdowns.nine_months" })}</option>
                  <option value="12">{t({ id: "dropdowns.year" })}</option>
                </Input>
              )}
              {!["ar", "lb"].includes(i18n.locale) && (
                <Input
                  type="date"
                  name="establishment_date"
                  placeholder={t({ id: "dropdowns.establishment_date" })}
                  value={state.establishment_date}
                  style={inputStyle}
                  onChange={onChange}
                  numberofmonths={1}
                  max={new Date().toISOString().slice(0, 10)}
                />
              )}
              <br />
              <Button
                className="btn btn-primary"
                onClick={updateGroup}
                color="primary"
                size="sm"
                block
                disabled={state.editButtonDisable}
                style={{ marginBottom: "10px" }}
              >
                <Trans id="save" />
              </Button>
            </>
          )}
          {!state.isEditing && (
            <Button
              className="btn btn-primary"
              onClick={toggleEditVsla}
              color="primary"
              size="sm"
              block
              disabled={!canEdit}
              style={{ marginBottom: "10px" }}
            >
              <Trans id="edit" />
            </Button>
          )}
          {props.isConnected && props.group?.id && props.group?.status === "Active" && (
            <Button
              className="btn btn-danger"
              onClick={deleteVsla}
              size="sm"
              block
              disabled={isDeletable}
            >
              <Trans id="delete" />
            </Button>
          )}
        </Container>
      </div>
    )
  }
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
  color: "#000",
}

GroupSummary.propTypes = {
  vslaSummary: PropTypes.array,
  vsla: PropTypes.object,
  isConnected: PropTypes.bool,
  ongoingMeeting: PropTypes.object,
  vslaBalance: PropTypes.array,
  vslaDebt: PropTypes.object,
  user: PropTypes.object,
  group: PropTypes.object,
  transportedLocationData: PropTypes.object,
  patchGroup: PropTypes.func,
  patchVsla: PropTypes.func,
  setPage: PropTypes.func,
  projects: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    isConnected: state.isConnected,
    currentPage: state.currentPage,
    error: state.error,
    group: state.group,
    vsla: state.vsla,
    ongoingMeeting: state.meeting?.ongoing,
    vslaBalance: selectBalance(state),
    vslaDebt: selectVslaDebtBalance(state),
    vslaSummary: selectCreatedVslaInfo(state),
    projects: state.projects,
    members: state.loadedvslaMembers.filter(
      (member) => member?.status === "Active" && member?.blockchain_wallet_id !== null,
    ),
    transportedLocationData: state.locationTransport,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    getMemberBalance: (id) => dispatch(getMemberBalanceByMemberId(id)),
    patchVsla: (url, data) => dispatch(patchVslaItem(url, data)),
    patchGroup: (url, data, headers) => dispatch(patchGroupItem(url, data, headers)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupSummary)
